import {DATETIME} from '@drivesally/sally-fw/lib/inputTypes';

import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

import {dateTime, apiDateTime} from '@drivesally/sally-fw/lib/type';

export default attribute({
  type: DATETIME,
  attribute: 'schedule_at',
  display: dateTime,
  input: dateTime,
  api: apiDateTime,
  label: {
    default: 'Recurring Schedule',
    short: 'Recurring Schedule',
  },
});
